var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortDown = function SvgSortDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.333h5.333V4H2zM2 8.667h4V7.333H2zM4.667 12H2v-1.333h2.667zM11.333 12.943l2.472-2.472-.943-.942-.862.861V4h-1.333v6.39l-.862-.861-.943.942z"
  })));
};
export default SvgSortDown;